import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appEnterDirective]'
})
export class EnterDirective {
    @Input() onEnterKey: boolean = true;

    @HostListener('keydown.enter', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (!this.onEnterKey) return;

        const currentElement: HTMLElement = document.activeElement as HTMLElement;

        if (currentElement) {
            // console.log('currentElement', currentElement);
            // console.log('currentElement.classList', currentElement.classList);

            // Skip elements that are icons or contain an icon inside a button
            if (currentElement.tagName === 'I' || currentElement.closest('button')?.querySelector('i')) {
                return;
            }

            // Handle specific element types
            if (currentElement instanceof HTMLInputElement) {
                if (currentElement.type === 'file') {
                    currentElement.click();
                } else if (currentElement.type === 'date' || currentElement.type === 'datetime-local') {
                    currentElement.showPicker();
                }
            } else if (currentElement.tagName === 'BUTTON') {
                currentElement.click();
                return;
            } else {
                event.preventDefault();
            }
            this.moveFocusToNextElement(event);
        }

    }

    private moveFocusToNextElement(event: KeyboardEvent): void {
        $(document).ready(() => {
            const focusableElements = $(
                ':input:not([disabled],[type="hidden"]), button:not([disabled]), a[routerLink]:not([disabled]), [tabindex]:not([disabled])'
            );

            focusableElements.keydown(function (e) {
                if (e.key === 'Enter') {
                    var nextElement = focusableElements.get(focusableElements.index(this) + 1);
                    if (nextElement) {
                        const nextElementAsHTMLElement = nextElement as HTMLElement;
                        
                        // Check if the next element is not an anchor tag with routerLink
                        if (!nextElementAsHTMLElement.closest('a[routerLink]')) {
                            nextElementAsHTMLElement.focus();
                        }
                    }
                }
            });
        });
    }
}
